export var Easing;
(function (Easing) {
    Easing["Linear"] = "Linear";
    Easing["QuadEaseIn"] = "Quad.easeIn";
    Easing["CubicEaseIn"] = "Cubic.easeIn";
    Easing["QuartEaseIn"] = "Quart.easeIn";
    Easing["QuintEaseIn"] = "Quint.easeIn";
    Easing["SineEaseIn"] = "Sine.easeIn";
    Easing["ExpoEaseIn"] = "Expo.easeIn";
    Easing["CircEaseIn"] = "Circ.easeIn";
    Easing["BackEaseIn"] = "Back.easeIn";
    Easing["BounceEaseIn"] = "Bounce.easeIn";
    Easing["QuadEaseOut"] = "Quad.easeOut";
    Easing["CubicEaseOut"] = "Cubic.easeOut";
    Easing["QuartEaseOut"] = "Quart.easeOut";
    Easing["QuintEaseOut"] = "Quint.easeOut";
    Easing["SineEaseOut"] = "Sine.easeOut";
    Easing["ExpoEaseOut"] = "Expo.easeOut";
    Easing["CircEaseOut"] = "Circ.easeOut";
    Easing["BackEaseOut"] = "Back.easeOut";
    Easing["BounceEaseOut"] = "Bounce.easeOut";
    Easing["QuadEaseInOut"] = "Quad.easeInOut";
    Easing["CubicEaseInOut"] = "Cubic.easeInOut";
    Easing["QuartEaseInOut"] = "Quart.easeInOut";
    Easing["QuintEaseInOut"] = "Quint.easeInOut";
    Easing["SineEaseInOut"] = "Sine.easeInOut";
    Easing["ExpoEaseInOut"] = "Expo.easeInOut";
    Easing["CircEaseInOut"] = "Circ.easeInOut";
    Easing["BackEaseInOut"] = "Back.easeInOut";
    Easing["BounceEaseInOut"] = "Bounce.easeInOut";
})(Easing || (Easing = {}));
